import { Navbar, Offcanvas, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

/* IMAGE */
import AmberwoodRELogo from "../assets/amberwood-re-logo.webp";

const Header = () => {
  return (
    <header className="header">
      <div className="container">
        <div className="header-links">
          <Link to="/">
            <div className="logo-box">
              <img src={AmberwoodRELogo} alt="Amberwood Real Estate Inc" />
            </div>
          </Link>
          <div className="navigation-links">
            <Navbar expand="xl">
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Offcanvas id="offcanvas-expand-lg" placement="end">
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title id="offcanvas-expand-lg">
                    <Link to="/">
                      <div className="logo-box">
                        <img
                          src={AmberwoodRELogo}
                          alt="Amberwood Real Estate Inc."
                        />
                      </div>
                    </Link>
                  </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  <Nav className="main-menu">
                    <Nav.Link href="/" className="menu-link">
                      Home
                    </Nav.Link>
                    <Nav.Link href="/buying" className="menu-link">
                      Buying
                    </Nav.Link>
                    <Nav.Link href="/selling" className="menu-link">
                      Selling
                    </Nav.Link>
                    <Nav.Link href="/home-evaluation" className="menu-link">
                      Home Evaluation
                    </Nav.Link>
                    <Nav.Link href="/active-listings" className="menu-link">
                      Active Listings
                    </Nav.Link>
                    <Nav.Link href="/blogs" className="menu-link">
                      Blogs
                    </Nav.Link>
                    <Nav.Link href="/contact-me" className="menu-link">
                      Contact Me
                    </Nav.Link>
                  </Nav>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </Navbar>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
